import { toastController } from '@ionic/vue'

interface ToastOptions {
  message: string
  duration?: number
  color?: 'success' | 'danger' | 'warning' | 'primary' | 'info'
  position?: 'top' | 'middle' | 'bottom'
  showCloseButton?: boolean
  onClick?: () => void
}

export function useToast() {
  const showToast = async ({
    message,
    duration = 5000,
    color = 'primary',
    position = 'top',
    showCloseButton = true,
    onClick
  }: ToastOptions) => {
    const toast = await toastController.create({
      message,
      duration: 5000,
      position: 'top',
      cssClass: `premium-toast ${color ? `toast-${color}` : ''}`,
      buttons: [
        ...(onClick ? [{
          text: 'View',
          role: 'info',
          handler: onClick
        }] : []),
        ...(showCloseButton ? [{
          text: 'Dismiss',
          role: 'cancel',
          handler: () => {
            toast.dismiss()
          }
        }] : [])
      ],
      animated: true,
      keyboardClose: true,
      mode: 'ios'
    })

    await toast.present()
    return toast
  }

  return {
    showToast
  }
} 